"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarLeftArrow = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var SidebarLeftArrow = function SidebarLeftArrow() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5 1L1 5L5 9",
      stroke: "black",
      strokeWidth: "0.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    })
  });
};
exports.SidebarLeftArrow = SidebarLeftArrow;